export default "__VITE_PUBLIC_ASSET__79d83b9e__"